<div class="grid grid-nogutter m-0">
  <ng-container *ngIf="showFilter">
    <div class="col-12 md:col-4">
        <split-search placeholder="Pesquisar nome paciente" (valueChange)="onSearchChange($event)"></split-search>
    </div>
    <div class="col-12 md:col-8 flex align-items-center justify-content-end">
        <split-group-filter (onFilterEvent)="onFilterChange($event)">
            <split-filter-range-date field="revenue.date" key="date" label="Data" ></split-filter-range-date>
            <split-filter-professional field="revenue.professional.id" label="Profissional" key="professional"></split-filter-professional>
            <split-filter-payment-method field="revenue.payments.paymentMethod" label="Forma de pagamento"  key="paymentMethod"></split-filter-payment-method>
        </split-group-filter>
    </div>
  </ng-container> 
  <div class="col-12 px-0">
      <split-table [paginator]="paginator" [totalRecords]="totalRecords" (pageChange)="pageChange($event)" [loading]="loadingListRevenue" [dados]="listRevenue" [theme]="theme">
          <ng-template #header>Id</ng-template>
          <ng-template #coluna let-item="dadosLinha">
              {{item.id}}
          </ng-template>
          <ng-template #header><div class="text-left">Pagador</div></ng-template>
          <ng-template #coluna let-item="dadosLinha">
             <split-text  [title]="item.revenue?.payer.firstName ? item.revenue?.payer.firstName+ ' ' +item.revenue.payer.lastName : 'Sem cliente'" [subtitle]="item.revenue?.payer.taxId| mask:'000.000.000-00||00.000.000/0000-00'"></split-text>
          </ng-template>
          <ng-template #header>Data</ng-template>
          <ng-template #coluna let-item="dadosLinha">
              {{item.revenue?.date | date:'dd/MM/yyyy'}}
          </ng-template>
          <ng-template #header>Profissional</ng-template>
          <ng-template #coluna let-item="dadosLinha">
              {{item.revenue?.professional?.name || '-'}}
          </ng-template>
          <ng-template #header>Serviço</ng-template>
          <ng-template #coluna let-item="dadosLinha">
              <split-truncate-text *ngIf="item.revenue?.service || item.revenue?.exam; else elseTemplate" width="200px" [text]="item.revenue.service ? item.revenue?.service?.name : item.revenue?.exam?.name"></split-truncate-text>
              <ng-template #elseTemplate>Sem serviço ou exame</ng-template>
          </ng-template>
          <ng-template #header>Valor</ng-template>
          <ng-template #coluna let-item="dadosLinha">
              {{item.revenue?.value | currency:'BRL'}}
          </ng-template>
          <ng-template #header>Pagamento</ng-template>
          <ng-template #coluna let-item="dadosLinha">
              <split-list-badge [list]="item.revenue?.payments" key="paymentMethod.name"></split-list-badge>
          </ng-template>
          <ng-template #header></ng-template>
          <ng-template #coluna let-item="dadosLinha">
              <div class="flex gap-2 align-items-center justify-content-center">
                  <p-button (click)="showEditRevenue(item.id)" [rounded]="true" [text]="true" severity="secondary">
                      <ng-template pTemplate="icon">
                          <div class="flex">
                              <split-icon name="edit" size="24px"></split-icon>
                          </div>
                      </ng-template>
                  </p-button>
                  <p-button [disabled]="item?.revenue?.isPaymentMachineOrder == true || ((item?.revenue?.unitInvoice || item?.revenue?.professionalInvoice) && (item?.revenue?.unitInvoice?.status != 'canceled' || item?.revenue?.professionalInvoice?.status != 'canceled'))" [rounded]="true" severity="danger" [text]="true" (click)="showDeleteRevenue(item.id)" >
                      <ng-template pTemplate="icon">
                          <div class="flex">
                              <split-icon name="trash" size="24px"></split-icon>
                          </div>
                      </ng-template>
                  </p-button>
                  <p-button  class="ml-3 hidden" [rounded]="true" severity="secondary" [text]="true" >
                      <ng-template pTemplate="icon">
                          <div class="flex">
                              <split-icon name="credit-card-pay" size="24px"></split-icon>
                          </div>
                      </ng-template>
                  </p-button>
                  <p-button  class="ml-3 hidden"  [rounded]="true" severity="success"  [text]="true" >
                      <ng-template pTemplate="icon">
                          <div class="flex">
                              <split-icon name="calendar-repeat" size="24px"></split-icon>
                          </div>
                      </ng-template>
                  </p-button>
              </div>
          </ng-template>
      </split-table>
  </div>
</div>

<p-dialog [(visible)]="showModalDelete" [dismissableMask]="true" styleClass="pDialog" [draggable]="false"
  [modal]="true">
  <div class="content">
      <img src="assets/lista-unidade/modal-deletar/deletar-unidade.svg" alt="imagem deletar funcionario">
      <span class="title">
          <p>Tem certeza que deseja deletar</p>
          <p>essa receita?</p>
      </span>
      <span class="message">
          <p>Ao confirmar você excluirá permanentemente</p>
          <p>a receita selecionada</p>
      </span>
  </div>
  <ng-template pTemplate="footer">
      <button class="cancelar" (click)="fecharDialog()">Cancelar</button>
      <button class="deletar" (click)="handleDelete()">Deletar</button>
  </ng-template>

</p-dialog>

